import { render, staticRenderFns } from "./study-home.vue?vue&type=template&id=5b5ae9c7&scoped=true"
import script from "./study-home.vue?vue&type=script&lang=js"
export * from "./study-home.vue?vue&type=script&lang=js"
import style0 from "./study-home.vue?vue&type=style&index=0&id=5b5ae9c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5ae9c7",
  null
  
)

export default component.exports